module.exports = __webpack_public_path__ + "static/media/24.0b49d73c.mp3";